import { __rest } from "tslib";
import { forwardRef } from 'react';
import { createReactWrapper } from '../common/PrefixUtils';
export const LinearProgress = forwardRef((_a, ref) => {
    var props = __rest(_a, []);
    return createReactWrapper({
        tagName: 'chameleon-linear-progress',
        props: Object.assign(Object.assign({}, props), { ref }),
    });
});
